
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  open(e) {
    e.preventDefault()

    const fukidashi = e.currentTarget.querySelector(".advertisement-fukidashi");
    if (!fukidashi) return;

    fukidashi.classList.toggle("active");

    // 外部クリック検知用にイベントリスナー追加
    this._handleClickOutside = (event) => {
      event.preventDefault()

      const clickedInside = this.element.contains(event.target);
      if (!clickedInside || event.target === e.currentTarget) {
        this.close();
      }
    };

    setTimeout(() => {
      document.addEventListener("click", this._handleClickOutside);
    }, 0);
  }

  close() {
    const fukidashi = this.element.querySelector(".advertisement-fukidashi.active");
    if (fukidashi) {
      fukidashi.classList.remove("active");
    }

    if (this._handleClickOutside) {
      document.removeEventListener("click", this._handleClickOutside);
      this._handleClickOutside = null;
    }
  }
}
